<template>
	<div class="input-group">
		<div class="input-group-prepend">
			<span class="input-group-text no-border-radius input-group-text-mobile" :class="[{'is-invalid': errorinfo.hasError}, {'disabled' : isProcessing}, inputclass]">
				<img :src="countryFlag" alt="country flag" style="padding-right: 10px;"> +{{countryCode}} <span class="input-mobile-border">&nbsp;</span></span>
		</div>
		<input class="form-control no-border-radius" @input="onInput" v-model="in_phone" 
			type="tel" 
			:placeholder="placeholder"
			:disabled="isProcessing"
			:class="[{'is-invalid': errorinfo.hasError}, inputclass]"/>
		<small class="invalid-feedback" v-if="errorinfo.hasError">{{errorinfo.msg}}</small>

		<div class="input-group pt-5" v-if="this.$gstate.isDev() || this.$gstate.isTest()">
			<div>
				<select class="form-control" @change="updateMobileNumber()" v-model="in_country">
					<option value="CA">Canada</option>
					<option value="AU">Australia</option>
					<option value="PH">Philippines</option>
					<option value="ID">Indonesia</option>
				</select>
				
				<input v-if="false" class="form-control" type="number" placeholder="Country Calling Code" v-model="countryCallingCode" />
				<small class="mt-1">Country field only visible for dev testing.  Not visible on production.</small>
			</div>
		</div>
		
	</div>
</template>

<script>
import { AsYouType, parseNumber, formatNumber, getCountryCallingCode, isValidNumber } from 'libphonenumber-js'

export default {
	props: {
		value: String,
		placeholder: String,
		inputclass: String,
		isProcessing: Boolean,
		fiatCurrency: String,
		phoneinfo: {type: Object, default: () => ({})},
		errorinfo: {type: Object, default: () => ({})}
	},
	mounted(){
		this.setCountry();
	},
	data: function() {
		return {
			in_country: 'CA',
			countryCallingCode: '1',
			in_phone: this.value,
			areaCodeBlacklist: []
		}
	},
	computed: {
		countryCode(){
			return getCountryCallingCode(this.in_country)
		},
		countryFlag(){
			return require("./../assets/img/flag_"+ this.in_country.toLowerCase() +"_icon.png");
		}
	},
	methods: {
		setCountry(){
			if(this.fiatCurrency == 'PHP'){
				this.in_country = 'PH';
			} else if (this.fiatCurrency == 'IDR') {
				this.in_country = 'ID'
			} else if (this.fiatCurrency == 'AUD') {
				this.in_country = 'AU'
			} else {
				this.in_country = 'CA'	// default
			}

		},
		onInput: function() {
			this.updateMobileNumber();
		},
		updateMobileNumber: function(){
			this.in_phone = new AsYouType(this.in_country).input(this.in_phone);
			this.phoneinfo.isValid = isValidNumber(this.in_phone, this.in_country);
			this.phoneinfo.countryCallingCode = getCountryCallingCode(this.in_country);	// returns the country code which is 1
			this.phoneinfo.country = this.in_country;

			var e164Number = '';
			if (this.phoneinfo.isValid) {
				e164Number = formatNumber(parseNumber(this.in_phone, this.in_country), 'E.164');
			}
			
			var number_without_country_code;
			
			if(this.in_country == "PH" || this.in_country == "ID" || this.in_country == "AU"){
				number_without_country_code = e164Number.substr(3); // removes +63 from the front
			} else {
				number_without_country_code = e164Number.substr(2); // removes +1 from the front
			}
			
			this.phoneinfo.phoneNumber = number_without_country_code.substr(3);
			this.phoneinfo.areaCode = number_without_country_code.substring(0,3);

			if(this.phoneinfo.areaCode != ""){
				if(this.areaCodeBlacklist.indexOf(parseInt(this.phoneinfo.areaCode)) > -1){
					this.phoneinfo.isValid = false;
					this.phoneinfo.errorMsg = "The region of Quebec is not supported.";
				}
			}
			
			this.phoneinfo.e164Number = e164Number;
			this.$emit('input', this.in_phone);
		}
	}
}
</script>